<template>
  <table class="listables-table">
    <thead>
      <th v-if='showCost' class="middle-align">EP</th>
      <th v-if='showName'>Name</th>
      <th v-if='showEffect'>Effect</th>
      <th v-if='showChainable'>Chainable?</th>
      <th v-if='showRequirements'>Requirements</th>
    </thead>
    <tr v-for="outcome in outcomes">
      <td v-if='showCost' class='middle-align'>{{ outcome.cost }}</td>
      <td v-if='showName' v-html="colorize(outcome.name)"></td>
      <td v-if='showEffect' v-html="colorize(outcome.effect)"></td>
      <td v-if='showChainable'>{{ outcome.chainable ? 'Chainable' : '' }}</td>
      <td v-if='showRequirements' v-html="colorize(outcome.requirements)"></td>
    </tr>
  </table>
</template>

<script>
import colorizeKeywords from './colorize.js';

export default {
  name: 'outcomes',

  methods: {
    colorize(text) { return colorizeKeywords(text); }
  },

  props: {
    outcomes: {
      type: Array,
      default: () => []
    },

    showOnly: {
      type: Array,
      default: () => {
        return ['name', 'cost', 'effect', 'chainable', 'requirements']
      }
    }
  },

  computed: {
    showCost: function() {
      return this.showOnly.includes('cost')
    },

    showName: function() {
      return this.showOnly.includes('name')
    },

    showEffect: function() {
      return this.showOnly.includes('effect')
    },

    showChainable: function() {
      return this.showOnly.includes('chainable')
    },

    showRequirements: function() {
      return this.showOnly.includes('requirements')
    },

  }
}
</script>
